import type { RouteLocationNamedRaw } from 'vue-router'
import { getRedirectQuery } from '@/utils/redirect-destination'

type ProtectedRouteAccess = {
  requiresAuth: boolean
  requiresPlanAccess: boolean
  isAuthenticated: boolean
  hasAccess: boolean
  destination: string
}

export function getProtectedRouteRedirect({
  requiresAuth,
  requiresPlanAccess,
  isAuthenticated,
  hasAccess,
  destination
}: ProtectedRouteAccess): RouteLocationNamedRaw | undefined {
  if ((requiresAuth || requiresPlanAccess) && !isAuthenticated) {
    return {
      name: 'sign-in',
      query: getRedirectQuery(destination)
    }
  }

  if (requiresPlanAccess && !hasAccess) {
    return {
      name: 'buy-subscription',
      query: getRedirectQuery(destination)
    }
  }
}
